export enum EErrorCode {
  PROFILE_NOT_COMPLETED = 'profile_not_completed',
  INSUFFICIENT_CREDITS = 'insufficient_credits'
}
